import React, { useState, useRef, useEffect } from 'react';
import { Check } from 'lucide-react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import PinPoint from '../../../../../../../assets/Admin/logo/imageContentMangePin.png';
import MediaPinPoint from '../../../../../../../assets/Admin/logo/imagePinMedia.png';
import { useTheme } from "../../../../../ThemeContext/ThemeContext"; // Importing the theme context
import { useNavigate } from 'react-router-dom';
import RoleServices from '../../../../../../servicces/RoleServices';
import { useAuth } from "../../../../../../../Providers/AuthProvider/AuthProvider";
import Pagination from "../../../../Layout/Pagination/PaginationBar"
import StatsOverview from './stats-overview';



const CustomCheckbox = React.forwardRef(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={`peer h-4 w-4 shrink-0 rounded-sm border border-[#909090] ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-[#036068] data-[state=checked]:text-primary-foreground ${className}`}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
      <Check className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
CustomCheckbox.displayName = CheckboxPrimitive.Root.displayName;

export default function UserManagement({ role }) {
  const [scrollPercentage, setScrollPercentage] = useState(0);
  const tableRef = useRef(null);
  const { isDarkMode, isLangArab } = useTheme(); // Access dark mode from theme context
  const [data, setData] = useState([]);
  const { setDropPinObjectId } = useAuth();
  const [totalItems, setTotalItems] = useState(0); // Example total items count
  // const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9; // Number of items per page
  const [totalRecords, setTotalRecords] = useState(0);
  const [approvedRecords, setApprovedRecords] = useState(0);
  const [pendingRecords, setPendingRecords] = useState(0);
  const [rejectedRecords, setRejectedRecords] = useState(0);

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage);
    console.log(`Selected page: ${selectedPage}`);
    // Here, you can load data for the selected page if using an API
  };
  console.log("Passed Content Management data :", data)

  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (tableRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = tableRef.current;
        const scrollPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;
        setScrollPercentage(scrollPercentage);
      }
    };

    const tableElement = tableRef.current;
    if (tableElement) {
      tableElement.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (tableElement) {
        tableElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
       const token = localStorage.getItem("token");
        const response = await fetch(`${process.env.REACT_APP_API_URL}/FeatureServiceData/GetFeatureServiceData`,{
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
        if (result.success) {
          const sortedItems = result.data.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          setTotalItems(sortedItems.length)
          setData(sortedItems);
          setTotalRecords(result.data.totalRecords);
          setApprovedRecords(result.data.approvedCount);
          setPendingRecords(result.data.pendingCount);
          setRejectedRecords(result.data.rejectedCount);
        } else {
          console.log(result.message);
        }
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchData();
  }, [data]);

  const handleDropPin = (objectID, featureServiceURL, id, POIOperation, featureObjectId, language) => {
    navigate({
      pathname: `/${process.env.REACT_APP_BASE_URL}`,
      search: `?sides=POIApproval`,
    });
    setDropPinObjectId({ objectID: objectID, featureServiceURL: featureServiceURL, id: id, POIOperation: POIOperation, featureObjectId: featureObjectId, isLanguageArabic: language });
    console.log("Admin DroppedPin clicked");
  };

  const paginatedData = data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


  return (
    <div className="flex h-[calc(100vh-6rem)]">

      <div className={`px-8 py-2 rounded-lg shadow-sm flex flex-col flex-grow overflow-hidden ${isDarkMode ? "bg-[#303031] bg-opacity-90" : "bg-white "
        } text-[#101828] backdrop-blur border-none`}>

        <StatsOverview totalRecords={totalRecords}
          approved={approvedRecords}
          pending={pendingRecords}
          rejected={rejectedRecords} />

        <div className="flex justify-between items-center mb-2">
          <h2 className={`text-[20px] font-500   ${isDarkMode ? "text-[#FFFFFFCC]" : "text-[#464646]"}`}>
            {isLangArab ? "إدارة المحتوى" : "Content Management"}</h2>
        </div>

        <hr className={`border-t  my-4 ${isDarkMode ? "border-[#FFFFFF] border-opacity-10" : "border-gray-300"}`} />

        <div className="overflow-x-auto laptop_s:overflow-hidden flex-grow relative">
          <div
            ref={tableRef}
            className={`overflow-x-auto overflow-y-auto absolute inset-0 ${isLangArab ? "pl-4" : "pr-4"}`}
          >
            <table className="w-full table-auto">
              <thead
                className={`sticky top-0 z-10 ${isDarkMode ? "bg-[#303031]" : "bg-white"}`}
              >
                <tr className="text-left text-sm    font-500 text-[#667085] border-b">
                  {[
                    { label: isLangArab ? "اسم المستخدم" : "Username" },
                    { label: isLangArab ? "معرف البريد الإلكتروني" : "Email ID" },
                    { label: isLangArab ? "التاريخ والوقت" : "  Date and Time" },
                    { label: isLangArab ? "اسم نقطة الاهتمام" : "POI Name" },
                    { label: isLangArab ? "المنظمة" : "Organization" },
                    { label: isLangArab ? "التصنيف" : "Classification" },
                    { label: isLangArab ? "البلدية" : "Municipality" },
                    { label: isLangArab ? "الوسائط" : "Media", icon: true },
                  ].map((header, idx) => (
                    <th
                      key={idx}
                      className={`pb-3 laptop_s:p-2 sm:p-1 p-2 font-500   text-[9px] sm:text-[10px] laptop_s:text-[14px] ${isLangArab ? "text-right " : "text-left "
                        } ${isDarkMode ? "text-[#FFFFFF]" : "text-[#667085]"}`}
                    >
                      <span className='flex  items-center gap-1 '>
                        {header.label}
                        {header.icon && (
                          <img
                            src={MediaPinPoint}
                            className={`${isDarkMode ? "filter invert brightness-0" : ""} h-[12px] w-[12px] inline-block`}
                            alt=""
                          />
                        )}
                      </span>
                    </th>
                  ))}
                  <th className="pb-3 laptop_s:p-4 laptop_m:p-2 sm:p-4"></th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((user, index) => (
                  <tr
                    key={index}
                    className={`${isDarkMode
                        ? index % 2 === 0
                          ? "bg-transparent"
                          : "bg-white bg-opacity-10"
                        : index % 2 === 0
                          ? "bg-[#D5E5DE] bg-opacity-30"
                          : "bg-white"
                      }`}
                  >
                    <td
                      className={`py-4 font-500   text-[10px] sm:text-[12px] laptop_s:text-[14px] ${isLangArab ? "pr-2" : "pl-2"
                        } ${isDarkMode ? "text-[#FFFFFF] text-opacity-60" : "text-[#101828]"} whitespace-nowrap`}
                    >
                      {user.email}
                    </td>
                    <td
                      className={`py-4 font-500   text-[10px] sm:text-[12px] laptop_s:text-[14px] ${isLangArab ? "pr-2" : "pl-2"
                        } ${isDarkMode ? "text-[#FFFFFF] text-opacity-60" : "text-[#101828]"} whitespace-nowrap`}
                    >
                      {user.username}
                    </td>
                    <td
                      dir={isLangArab && "ltr"}
                      className={`py-4 font-500   text-[10px] sm:text-[12px] laptop_s:text-[14px] ${isLangArab ? "pr-2 text-right" : "text-left pl-2"
                        } ${isDarkMode ? "text-[#FFFFFF] text-opacity-60" : "text-[#101828]"} whitespace-nowrap`}
                    >
                      {new Date(`${user.createdAt}Z`).toLocaleString()}
                    </td>
                    <td
                      className={`py-4 font-500   text-[10px] sm:text-[12px] laptop_s:text-[14px] ${isLangArab ? "pr-2" : "pl-2"
                        } ${isDarkMode ? "text-[#FFFFFF] text-opacity-60" : "text-[#101828]"} whitespace-nowrap`}
                    >
                      {/* {user.nameEn} */}
                      {isLangArab ? user.nameAr : user.nameEn}
                    </td>
                    <td
                      className={`py-4 font-500   text-[10px] sm:text-[12px] laptop_s:text-[14px] ${isLangArab ? "pr-2" : "pl-2"
                        } ${isDarkMode ? "text-[#FFFFFF] text-opacity-60" : "text-[#101828]"} whitespace-nowrap`}
                    >
                      {/* {user.organizationEn} */}
                      {isLangArab ? user.organizationAr : user.organizationEn}
                    </td>
                    <td
                      className={`py-4 font-500   text-[10px] sm:text-[12px] laptop_s:text-[14px] ${isLangArab ? "pr-2" : "pl-2"
                        } ${isDarkMode ? "text-[#FFFFFF] text-opacity-60" : "text-[#101828]"} whitespace-nowrap`}
                    >
                      {/* {user.classification} */}
                      {isLangArab ? user.classificationDAr : user.classification}
                    </td>
                    <td
                      className={`py-4 font-500   text-[10px] sm:text-[12px] laptop_s:text-[14px] ${isLangArab ? "pr-2" : "pl-2"
                        } ${isDarkMode ? "text-[#FFFFFF] text-opacity-60" : "text-[#101828]"} whitespace-nowrap`}
                    >
                      {/* {user.municipality} */}
                      {isLangArab ? user.municipalityAr : user.municipality}
                    </td>
                    <td
                      className={`py-4 font-500   text-[10px] sm:text-[12px] laptop_s:text-[14px] ${isLangArab ? "pr-2" : "pl-2"
                        } ${isDarkMode ? "text-[#FFFFFF] text-opacity-60" : "text-[#101828]"} whitespace-nowrap`}
                    >
                      {user.attachementsObjectIds
                        ? user.attachementsObjectIds.split(",").length
                        : 0}
                    </td>
                    <td className="py-4 w-auto sm:w-8 whitespace-nowrap">
                      <button
                        onClick={() => {
                          handleDropPin(
                            user.featureObjectId,
                            user.featureServiceURL,
                            user.id,
                            user.poiOperation,
                            user.featureObjectId,
                            user.isLanguageArabic
                          );
                        }}
                        className="text-red-500 hover:text-red-600"
                      >
                        <img
                          src={PinPoint}
                          alt=""
                          className={` h-[24px] w-[24px] `}
                        />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className=' flex justify-end'>
          <Pagination
            currentPage={currentPage} totalPages={totalItems} onPageChange={handlePageChange}
          />
        </div>
      </div>
      {data.length > 0 && <div className={`w-2 rounded-full mr-3 mt-12 mb-10 ml-2 relative ${isDarkMode ? "bg-[rgba(96,96,96,0.8)]" : "bg-[rgba(96,96,96,0.8)]"
        } text-[#101828] backdrop-blur border-none`}>
        <div
          className="w-full bg-[#B2CACC] absolute rounded-full transition-all duration-300 ease-out"
          style={{
            height: `${scrollPercentage}%`,
            top: '0',
          }}
        ></div>
      </div>}
    </div>
  );
}
